import {
    AfterContentInit,
    AfterViewInit,
    Component,
    ContentChildren,
    ElementRef,
    EventEmitter,
    HostBinding,
    HostListener,
    Input,
    OnDestroy,
    OnInit,
    Output,
    QueryList,
    ViewChild
} from "@angular/core";
import {MessageDetails, MessageLayout, MessageLevel} from "./message";
import {NotificationService} from "../notification.service";
import {Subscription} from "rxjs/Subscription";
import {IconButtonType} from "../../buttons/icon-button/icon-button";
import {LinkComponent} from "../../buttons/link/link.component";

export class AbstractMessage implements OnInit, AfterViewInit, AfterContentInit, OnDestroy {
    IconButtonType = IconButtonType;

    @Input() message: MessageDetails;
    @Input() level: MessageLevel = MessageLevel.INFO;
    @Input() icon: string;
    @Input() text: string;
    @Input() translationParams: any = {};
    @Input() showIcon: boolean = true;
    @Input() layout: MessageLayout = MessageLayout.VERTICAL;
    @Input() @HostBinding("class.closable") closable: boolean = false;
    @Input() @HostBinding("class.actionable") actionable: boolean = false;

    @Output() onClose: EventEmitter<void> = new EventEmitter();

    // noinspection Annotator
    @ViewChild("messageBody", {read: ElementRef}) private messageBody: ElementRef;
    @ContentChildren(LinkComponent) private links: QueryList<LinkComponent>;

    @HostBinding("class.errorLevel") get isErrorLevel(): boolean {
        return this.level === MessageLevel.ERROR;
    }

    @HostBinding("class.warningLevel") get isWarningLevel(): boolean {
        return this.level === MessageLevel.WARNING;
    }

    @HostBinding("class.successLevel") get isSuccessLevel(): boolean {
        return this.level === MessageLevel.SUCCESS;
    }

    @HostBinding("class.infoLevel") get isInfoLevel(): boolean {
        return this.level === MessageLevel.INFO;
    }

    @HostBinding("class.horizontal") get isHorizontalLayout(): boolean {
        return this.layout === MessageLayout.HORIZONTAL;
    }

    @HostBinding("class.vertical") get isVerticalLayout(): boolean {
        return this.layout === MessageLayout.VERTICAL;
    }

    @HostListener("click", ["$event"])
    buttonClicked(event: MouseEvent): void {
        event.stopPropagation();
        if (this.closable) {
            this.onClose.emit();
        }
    }

    private subscriptions: Subscription = new Subscription();

    constructor(private element: ElementRef,
                public notificationService: NotificationService) {
        this.subscriptions.add(notificationService.footerMessagesChanged$.subscribe(() => this.setMaxHeight()));
    }

    get iconName(): string {
        if (this.icon) {
            return this.icon;
        }
        switch (this.level) {
            case MessageLevel.ERROR:
                return "exclamation-circle";
            case MessageLevel.WARNING:
                return "warning-triangle";
            case MessageLevel.SUCCESS:
                return "check-circle";
            case MessageLevel.INFO:
                return "information-circle";
        }
    }

    ngOnInit(): void {
        if (this.message) {
            this.level = this.message.level;
            this.text = this.message.text;
            this.translationParams = this.message.translationParams;
            this.icon = this.message.icon;
            this.showIcon = this.message.showIcon;
        }
    }

    ngAfterViewInit(): void {
        setTimeout(() => this.setMaxHeight());
    }

    ngAfterContentInit(): void {
        this.subscriptions.add(this.links.changes.subscribe(() => this.setMaxHeight()));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    setMaxHeight(): void {
        if (this.message && this.message.closed) {
            this.element.nativeElement.style.removeProperty("max-height");
            this.element.nativeElement.style.border = "none";
        } else if (this.messageBody.nativeElement.scrollHeight < 35) {
            setTimeout(() => this.setMaxHeight(), 500);
        } else {
            this.element.nativeElement.style.maxHeight = this.messageBody.nativeElement.scrollHeight + "px";
            this.element.nativeElement.style.removeProperty("border");
            setTimeout(() => this.setMaxHeight(), 500);
        }
    }
}

@Component({
    selector: "woa-content-message",
    templateUrl: "./message.component.html"
})
export class ContentMessageComponent extends AbstractMessage {
    constructor(element: ElementRef,
                notificationService: NotificationService) {
        super(element, notificationService);
    }
}

@Component({
    selector: "woa-footer-message",
    templateUrl: "./message.component.html"
})
export class FooterMessageComponent extends AbstractMessage {
    constructor(element: ElementRef,
                notificationService: NotificationService) {
        super(element, notificationService);
    }
}



// WEBPACK FOOTER //
// ./src/app/notification/message/message.component.ts